import { getFullName } from 'utilities/name-utils';
import { commaDelimit } from 'utilities/string-utils';
import { Classroom, ClassroomRoleClassification, User } from 'types/schema-generated-types';

//TODO: This is temporary pending a solution to backend changes.
export const getEducators = (classroom: Classroom): { educator?: User; coeducators: User[] } => {
  let educator: User | undefined;
  const coeducators: User[] = [];

  if (classroom.users) {
    classroom.users.forEach(({ classroomRoles, user }) => {
      if (classroomRoles.some(cr => cr.classification === ClassroomRoleClassification.EDUCATOR)) {
        educator = user;
      } else if (
        classroomRoles.some(cr => cr.classification === ClassroomRoleClassification.COEDUCATOR)
      ) {
        coeducators.push(user);
      }
    });
  }

  return { educator, coeducators };
};

export const getEducatorNames = (
  classroom: Classroom
): { educator?: string; coeducators: string } => {
  const { educator, coeducators } = getEducators(classroom);

  return {
    ...(educator && { educator: getFullName(educator) }),
    coeducators: commaDelimit(coeducators.map(coed => getFullName(coed)))
  };
};
